export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-800 text-white">
      <div className="max-w-6xl mx-auto px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          {/* Logo & Name */}
          <div className="col-span-1 md:col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <img
                src="https://public.readdy.ai/ai/img_res/f5d6660d-0404-49ec-a2ea-dec9e29f0147.png"
                alt="カーサービス田中自動車 ロゴ"
                className="h-10 w-auto object-contain brightness-0 invert"
              />
              <span className="font-bold text-base">カーサービス田中自動車</span>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed">
              地域の皆様の安心・安全なカーライフを<br />
              誠実な整備でサポートします。
            </p>
          </div>

          {/* Service Links */}
          <div>
            <h4 className="font-semibold text-sm text-gray-300 uppercase tracking-wider mb-4">サービス</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li>
                <a href="#services" className="hover:text-white transition-colors cursor-pointer">車検・一般整備</a>
              </li>
              <li>
                <a href="#services" className="hover:text-white transition-colors cursor-pointer">板金・塗装</a>
              </li>
              <li>
                <a href="#services" className="hover:text-white transition-colors cursor-pointer">タイヤ交換・販売</a>
              </li>
              <li>
                <a href="#services" className="hover:text-white transition-colors cursor-pointer">一般修理</a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold text-sm text-gray-300 uppercase tracking-wider mb-4">お問い合わせ</h4>
            <div className="space-y-3 text-sm text-gray-400">
              <div className="flex items-start gap-2">
                <div className="w-4 h-4 flex items-center justify-center mt-0.5">
                  <i className="ri-map-pin-2-line text-green-400" />
                </div>
                <span>〒000-0000<br />○○県○○市○○町 0-0-0</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-phone-line text-green-400" />
                </div>
                <a href="tel:0000000000" className="hover:text-white transition-colors">000-000-0000</a>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-time-line text-green-400" />
                </div>
                <span>月〜土 8:00〜18:00 ／ 日・祝 定休</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-700">
        <div className="max-w-6xl mx-auto px-6 py-4 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="text-gray-500 text-xs">
            &copy; {currentYear} カーサービス田中自動車. All Rights Reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
